module.exports = __webpack_public_path__ + "img/in-use-noor-al-almer@2x.f3b4aa62.jpg";